import { ContainerModule } from 'inversify';
import { TermService, TermServiceSymbol } from './term-service';

export const termModule = new ContainerModule((bind) => {
  bind<TermService>(TermServiceSymbol).to(TermService).inSingletonScope();
});
